import React from "react";

export const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_brand-intel-10/artifacts/4mhgz0r5_Growth.webp";

// The wordmark is white + green, so it sits on a dark pill to stay legible on
// light surfaces (a green backdrop would hide the green arrow).
export function Logo({ height = 24, bare = false, className = "" }) {
  const img = <img src={LOGO_URL} alt="Growth" style={{ height, display: "block", width: "auto" }} />;
  if (bare) return <span className={`inline-flex items-center ${className}`}>{img}</span>;
  return (
    <span
      className={`inline-flex items-center rounded-xl ${className}`}
      style={{ background: "var(--grad-ink)", padding: `${Math.round(height * 0.42)}px ${Math.round(height * 0.6)}px` }}
    >
      {img}
    </span>
  );
}

export default Logo;
